<template>
  <div>
    <div class="d-flex flex-direction: row;">
      <div
        v-for="(slot, i) in localSlots"
        v-bind:style="{
          backgroundColor: disabled ? disabledColor : (slot.selected ? selectedColor : unselectedColor),
          height: height + 'px',
        }"
        :key="i"
        class="bar flex-grow-1"
        @click="toggle(slot,i, $event)"
      ></div>
    </div>
    <template v-if="showTime">
    <div class="d-flex grow flex-direction: row;">
      <div v-for="(slot, i) in slots.length" class="tick flex-grow-1" :key="i">
        {{ toTime(i) }}
      </div>
    </div>
    </template>
  </div>
</template>

<script>
export default {
  data() {
    return {
        localSlots: [],
        disabledColor: "#757575"
    };
  },

  methods: {
    toTime(slot) {
      if (slot == 0) {
        return "12am";
      }
      let index = (24 / this.slots.length) * slot;
      let hour = index % 12;
      if (hour == 0) hour = 12;
      return `${hour}${index >= 12 ? "pm" : "am"}`;
    },

    toggle(slot, index, evt) {
        if (this.showTime) {
            evt.preventDefault()
            slot.selected = !slot.selected
            this.$emit("selected", slot, index)
        }
    }
  },

  props: {
    slots: {
      type: Array,
      default: () => {
        return [];
      },
    },

    height: {
      type: Number,
      default: 8,
    },

    unselectedColor: {
      type: String,
      default: "red",
    },

    selectedColor: {
      type: String,
      default: "green",
    },

    showTime: {
        type: Boolean,
        default: true
    },

    disabled: {
        type: Boolean,
        default: false
    }
  },

  mounted() {
      if (this.slots.length && (24 / this.slots.length) % 1 !== 0) {
          console.log(`ERROR: TimeSlice slot length (${this.slots.length}) must be a factor of 24!!!`)
          return
      }
      this.localSlots = this.$clone(this.slots)
  },

  watch: {
    slots(val) {
        if (val) {
            this.localSlots = this.$clone(this.slots)
        }
    }
  }
};
</script>

<style scoped>
.bar {
  border-right: 2px solid black;
}

.bar:first-child {
  border-top-left-radius: 2rem;
  border-bottom-left-radius: 2rem;
}

.bar:last-child {
  border-top-right-radius: 2rem;
  border-bottom-right-radius: 2rem;
  border-right: none;
}

.tick {
  color: red;
  text-align: left;
  font-size: 10px;
}
</style>